import React from 'react';
import { FiMenu, FiSun, FiMoon } from 'react-icons/fi';
import { useTheme } from '../../context/ThemeContext';

export default function Header({ onToggleSidebar }) {
  const { theme, toggleTheme } = useTheme();

  return (
    <header style={styles.header}>
      <button onClick={onToggleSidebar} style={styles.menuBtn}>
        <FiMenu size={22} />
      </button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <img src="/logo.png" alt="ReplyCraft" style={{ width: 24, height: 24, borderRadius: 4 }} />
        <span style={styles.title}>ReplyCraft</span>
      </div>
      <button onClick={toggleTheme} style={styles.themeToggleBtn} title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
        {theme === 'dark' ? <FiSun size={18} /> : <FiMoon size={18} />}
      </button>
    </header>
  );
}

const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    borderBottom: '1px solid var(--border)',
    background: 'var(--bg-secondary)'
  },
  menuBtn: {
    background: 'none',
    border: 'none',
    color: 'var(--text-primary)',
    cursor: 'pointer',
    padding: 8,
    display: 'flex',
    borderRadius: 8
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    color: 'var(--text-primary)'
  },
  themeToggleBtn: {
    background: 'none',
    border: '1px solid var(--border)',
    color: 'var(--text-secondary)',
    cursor: 'pointer',
    padding: 8,
    display: 'flex',
    borderRadius: 8,
    transition: 'background 0.2s, color 0.2s'
  }
};
